import axios from 'axios';
import config from '../../../constants/config';

import store from '../../../store/store';
import { removeSessionToken } from '../../../store/actions/session';
import { nbsWSClose } from '../../../store/actions/socket';
import { deleteReduxStateFromStorage } from '../utils';

const nbsAxiosInstance = axios.create({
  baseURL: config.NBS_API_URL,
  method: 'POST',
  timeout: 30000,
  headers: { 'x-client-version': config.VERSION },
});

nbsAxiosInstance.interceptors.request.use(
  (request) => {
    // console.log('request', request);
    return request;
  },
  (error) => {
    // console.log('request error', error);
    return Promise.reject(error);
  }
);

nbsAxiosInstance.interceptors.response.use(
  (response) => {
    // console.log('response', response);
    if (response.data.success === false) {
      if (
        (config.ENVIRONMENT !== 'production' &&
          [101, 102, 104].includes(response.data.error_code)) ||
        response.data.error_code === 106 // We are currently down for scheduled maintenance. We will be back soon!
      ) {
        // alert(response.data.error);
      }

      if (response.data.error_code === 100) {
        // invalid token - logout and/or delete cookie
        nbsWSClose();
        store.dispatch(removeSessionToken());
        deleteReduxStateFromStorage();
      }
    }
    return response;
  },
  (error) => {
    // console.log('response error', error.message);
    if (!error.response) {
      // network error
      error = {
        ...error,
        success: false,
        error_code:
          (Object.prototype.hasOwnProperty.call(error, 'code') && error.code) ||
          9999,
        error: error.message,
      };
    } else {
      // response data = error.response.data
      if (error.code === 'ECONNABORTED' || error.response.status === 408) {
        // timeout
        error = {
          ...error,
          success: false,
          error_code: error.code || error.response.status,
          // error: `A timeout happened on url ${error.config.url}`
          error: error.message,
        };
      } else if (error.response.status > 399) {
        //  alert(error.message);
        if (error.response.status === 401 || error.response.status === 403) {
          // logout and/or delete cookie
          nbsWSClose();
          store.dispatch(removeSessionToken());
          deleteReduxStateFromStorage();
        }
      }
    }
    return Promise.reject(error);
  }
);

export default nbsAxiosInstance;
